export default {"src":"/_next/static/media/credit_service_phone.198c3450.svg","height":405,"width":480};